var debounceTimer = [];
export default function (func, timeout = 300, name = 'default') {
  function debouncer() {
    clearTimeout(debounceTimer[name]);
    debounceTimer[name] = setTimeout(() => {
      func();
    }, timeout);
  }

  return debouncer();
}
